import { Pause, Play } from "lucide-react";
import React, { useState, useRef } from "react";

const AudioPlayer = ({ url }) => {
  const [isPlaying, setIsPlaying] = useState(false); // State to toggle play/pause
  const audioRef = useRef(new Audio(url)); // Ref to manage the Audio object

  // Function to toggle play/pause
  const handlePlayPause = () => {
    if (!isPlaying) {
      audioRef.current.play(); // Play audio
      setIsPlaying(true);
    } else {
      audioRef.current.pause(); // Pause audio
      setIsPlaying(false);
    }
  };

  // Event listener for when audio ends
  audioRef.current.onended = () => {
    setIsPlaying(false); // Reset to play icon when audio ends
  };

  return (
   <div>
    {/* <img
      src={isPlaying ? "/icons/pause_record.png" : "/icons/play.png"} // Dynamic icon
      className="w-[24px] cursor-pointer"
      onClick={handlePlayPause} // Play/Pause logic
      alt="Play/Pause"
    /> */}
    {isPlaying ? (
      

      <div className="bg-[#DAEAFE] px-2 py-1 rounded-[6px]  w-fit"       onClick={handlePlayPause}>
      <Pause className="w-[17px] text-[#1F2937] " />
      </div>
       
    ): (
      <div className="bg-[#DAEAFE] px-2 py-1 rounded-[6px]  w-fit"       onClick={handlePlayPause}>
      <Play className="w-[17px] text-[#5473C7] " />
      </div>
    )} 
   </div>
  );
};

export default AudioPlayer;
